import { createApp } from "vue";
import App from "./App.vue";
import Vue3BaiduMapGL from "vue3-baidu-map-gl";
const app = createApp(App);
import axios from "axios";
import router from "./router/router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
app
  .use(Vue3BaiduMapGL, {
    ak: "AyQ4ucXrNlAKYUdyUf0mRTcdCxNuBNNf",
  })
  .use(router)
  .use(ElementPlus);
app.mount("#app");
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
// axios请求拦截
axios.interceptors.request.use((config) => {
  // 为请求头对象，添加Token验证的token字段
  const token = localStorage.getItem("postal-token");
  if (token) {
    config.headers["postal-token"] = token;
  }
  return config;
});

axios.interceptors.response.use((res) => {
  if (res.data.code === 403) {
    localStorage.removeItem("postal-token");
    // ElMessage.warning("登录有效期已过，麻烦重新登录下啦");
    router.push({
      path: "/login",
      query: { redirect: router.currentRoute.fullPath }, //登录成功后跳入浏览的当前页面
    });
  }
  return res;
});
